import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client'
import App from './components/app';
// import App from './components/app.tsx';   for typescript

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// another way to do without using strict mode
// createRoot(document.getElementById('root')).render(<App />);

